<mat-sidenav-container [ngClass]="!isLogged() ? 'sidenav-container-loggin' : 'sidenav-container'" [hasBackdrop]="false">

    <mat-sidenav #drawer class="sidenav" fixedInViewport="true"
                 [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
                 [mode]="(isHandset$ | async) ? 'over' : 'side'"
                 [opened]="menuItems && menuItems.length > 0 && !(isHandset$ | async)">
        <app-sidenavHeader></app-sidenavHeader>
        <app-menu [items]="menuItems" (itemClicked$)="menuItemClicked(drawer)"></app-menu>
    </mat-sidenav>
    <mat-sidenav-content>
        <header>
            <app-header [drawer]="drawer" [menuAvailable]="menuItems && menuItems.length > 0" [title]=""
                        [isHandset$]="isHandset$"></app-header>
        </header>
        <main [ngClass]="!isLogged() ? 'main-loggin' : 'main'">
            <router-outlet></router-outlet>
        </main>
        <footer>
            <!-- OCULTAMOS EL FOOTER: NO APORTA INFORMAICÓN AL PANEL
             <app-footer *ngIf="isLogged()"></app-footer>

                  OCULTAMOS EL FOOTER -->
        </footer>
    </mat-sidenav-content>
</mat-sidenav-container>
<div class="cargando_overlay" *ngIf="cargando && isLogged() && mostrarCargando">
    <!--    <div>CARGANDO DATOS. POR FAVOR, ESPERE ...</div>-->
</div>
